module.exports = __webpack_public_path__ + "static/media/pic_banner_more.fde35d57.jpg";